(() => {
	'use strict';

	angular.module('bmsApp.instantMessaging', [
	])
		.directive('instantMessaging', function () {
			return {
				restrict: 'E',
				replace: true,
				scope: {},
				templateUrl: 'ng/global/instant-messaging/templates/instant-messaging.html',
				controller: 'InstantMessagingCtrl',
				controllerAs: 'IM'
			};
		});
})();

